import Button from '@/common/components/Button'
import { EstablishmentInfrastructureData } from '@/common/types/establishmentInfrastructure'
import { ArrowBigRight, LandPlotIcon } from 'lucide-react'
import { Link } from 'react-router-dom'

export class EstablishmentInfrastructuresTransformer {
  static tableTransformer() {
    return (establishmentInfrastructures: EstablishmentInfrastructureData[]) => {
      return establishmentInfrastructures.map((establishmentInfrastructure) => {
        return {
          ...establishmentInfrastructure,
          action: (
            <Link to={`/establishment-infrastructures/${establishmentInfrastructure.id}`}>
              <Button
                variant="link-white"
                className="w-full"
                operationKlassToCheckPermission="Admin::Maintenance::EstablishmentInfrastructures::Show"
              >
                <ArrowBigRight />
              </Button>
            </Link>
          ),
        }
      })
    }
  }

  static optionsTransformer() {
    return (establishmentInfrastructures: EstablishmentInfrastructureData[]) => {
      return establishmentInfrastructures.map((establishmentInfrastructure) => {
        return {
          value: establishmentInfrastructure.id,
          label: establishmentInfrastructure.display_name,
          icon: <LandPlotIcon strokeWidth={1} size={20} />
        }
      })
    }
  }
}
